"use client"

import { getProfile } from "@/lib/data"
import { useEffect, useState } from 'react';
import { AppSidebar } from "@/components/app-sidebar"
import { ChartAreaInteractive } from "@/components/chart-area-interactive"
//import { DataTable } from "@/components/data-table"
import { SectionCards } from "@/components/section-cards"
import { SiteHeader } from "@/components/site-header"
import {
  SidebarInset,
  SidebarProvider,
} from "@/components/ui/sidebar"

import data from "./data.json"

export default function Layout({ children }: { children: React.ReactNode }) {

  const [token, setToken] = useState<string | null>('___')
  const [profile, setProfile] = useState<string | null>('0')

  
  useEffect(() => {
      // При обновлении страницы очищаем localStorage
      localStorage.removeItem('obrs')
      localStorage.removeItem('polis')

      let tk = localStorage.getItem('token')
       setToken(tk)
       if (!tk) {window.location.replace("https://lk.kapmed.ru/login")} else {
         getProfile(setProfile, tk)
      }
  }, []);


  return (
    <>
    {profile == '1' ? (<SidebarProvider
      style={
        {
          "--sidebar-width": "calc(var(--spacing) * 72)",
          "--header-height": "calc(var(--spacing) * 12)",
        } as React.CSSProperties
      }
    >
      <AppSidebar variant="inset" />
      <SidebarInset>
        <SiteHeader />
        <div className=" h-2 grow p-3 overflow-y-auto ">{children}</div>
      </SidebarInset>
    </SidebarProvider>) : (null)}
    
    </>
  )
}
